import React, { useState, useContext, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import logophoto from "./../../assets/logos/ColorVertical.png";
import APILogin from "../../components/api/APILogin";
import APIToken from "../../components/apiToken/APIToken";

import Snackbar from "@mui/material/Snackbar";
import { useNavigate } from "react-router-dom";

import AuthContext from "../../context/AuthContext";
import { host } from "../../components/utils";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright ©"}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme();

export default function Login() {
  let { isAuthenticated, setIsAuthenticated, setAuthToken, setIsAdmin } =
    useContext(AuthContext);
  let navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  const [values, setValues] = useState({
    username: "",
    password: "",
    error: "",
  });

  useEffect(() => {
    if (isAuthenticated) navigate("/");
    // console.log("useffect login");
  }, []);

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    let data = { username: values.username, password: values.password };
    APIToken.post("", data)
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("authTokens", JSON.stringify(response.data));
          setAuthToken(response.data.access);
          setIsAuthenticated(true);
          if (response.data.staff) {
            APILogin.post("", data).then(function (response) {
              if (response.data.success == "User authenticated") {
                setIsAdmin(true);
              }
            });
          }
          navigate("/");
        } else {
          alert("Something went wrong!");
        }
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage("Incorrect username or password");
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* <img width={200} margin={2} src={logophoto} /> */}
          {/* <Typography component="h1" variant="h5">
            Sign in
          </Typography> */}
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Username (case sensitive) "
              name="email"
              autoComplete="email"
              onChange={handleChange("username")}
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={handleChange("password")}
            />
            {errorMessage && (
              <Box sx={{ color: "error.main" }}> {errorMessage} </Box>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
